import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@airia/ui';
import { useMcpConnectionError, useMcpConnectionStatus } from './McpSessionProvider';
const STATUS_CONFIG = {
    connecting: {
        className: 'bg-amber-400 animate-pulse',
        label: 'Connecting to Airia...',
    },
    connected: {
        className: 'bg-emerald-500',
        label: 'Connected to Airia',
    },
    reconnecting: {
        className: 'bg-orange-500 animate-pulse',
        label: 'Reconnecting to Airia...',
    },
    disconnected: {
        className: 'bg-red-500',
        label: 'Disconnected from Airia',
    },
};
export function SignalRStatusDot() {
    const status = useMcpConnectionStatus();
    const connectionError = useMcpConnectionError();
    if (!status)
        return null;
    const { className, label } = STATUS_CONFIG[status];
    const errorDetail = (status === 'disconnected' || status === 'reconnecting') && connectionError?.message
        ? connectionError.message
        : null;
    return (_jsx(TooltipProvider, { children: _jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: _jsx("div", { role: "status", "aria-label": label, "aria-live": "polite", className: "flex items-center justify-center w-5 h-5 cursor-default", children: _jsx("div", { className: `w-2 h-2 rounded-full ${className}` }) }) }), _jsxs(TooltipContent, { side: "left", children: [_jsx("p", { children: label }), errorDetail && _jsx("p", { className: "mt-1 text-xs opacity-75", children: errorDetail })] })] }) }));
}
